<home-navbar [user]="user" [username]="username"></home-navbar>
<main>
  <home-header [defaultPreview]="user?.settings?.background"
               [program]="currentProgram"
               [stepperLink]="stepperLink"></home-header>
  
  <ng-container *ngIf="programs.industry.length || programs.company.length; else emptyState">
    <home-programs *ngIf="programs.industry.length"
                   [username]="username"
                   [programs]="programs.industry"
                   [currentProgramName]="currentProgram?.name"></home-programs>
    
    <home-mortgage *ngIf="programs.company.length"
                   [username]="username"
                   [companyName]="user.company_name"
                   [programs]="programs.company"
                   [stepperLink]="stepperLink"></home-mortgage>
  </ng-container>
  
  <ng-template #emptyState>
    <empty-programs></empty-programs>
  
<!--    https://loomlogic.atlassian.net/browse/SOA-8236-->
<!--    home-apply(-->
<!--      [preview]="currentProgram?.content_preview",-->
<!--      [username]="username",-->
<!--      [partner]="partner"-->
<!--    )-->
  </ng-template>
  
  <home-process></home-process>
  
  <home-questions></home-questions>
  
  <home-certificate [stepperLink]="stepperLink"></home-certificate>
  
  <home-specialist [user]="user"></home-specialist>
</main>
<home-footer></home-footer>
